import { FC } from 'react';
import {HeaderContent} from "./HeaderContent";
import {HeaderOrgLogo} from "./HeaderOrgLogo";
import {HeaderOrgName} from "./HeaderOrgName";
import {HeaderPageTitle} from "./HeaderPageTitle";
import {HeaderPageIcon} from "./HeaderPageIcon";
import {HeaderPageImage} from "./HeaderPageImage";

interface HeaderProps {
    children?: any,
}

interface HeaderInterface extends FC<HeaderProps> {
    PageTitle: typeof HeaderPageTitle;
    PageIcon: typeof HeaderPageIcon;
    PageImage: typeof HeaderPageImage;
    OrgName: typeof HeaderOrgName;
    OrgLogo: typeof HeaderOrgLogo;
    Content: typeof HeaderContent;
}

const Header: HeaderInterface = ({children}) => {
    return children;
}

Header.PageTitle = HeaderPageTitle;
Header.PageIcon = HeaderPageIcon;
Header.PageImage = HeaderPageImage;
Header.OrgName = HeaderOrgName;
Header.OrgLogo = HeaderOrgLogo;
Header.Content = HeaderContent;
export default Header;
